import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getSubscriptionAgreementService, getTradeConfirmationService } from '../../services/StatementsAPI';
import { toastNotify } from '../../utils/toastNotify';

const initialState = {
  tradingConfirmationList: {
    totalCount: 0,
    totalPage: 0,
    tradingConfirmationData: [],
  },
  subscriptionAgreementsList: {
    totalCount: 0,
    totalPage: 0,
    subscriptionAgreementData: [],
  },
};

export const getTradeConfirmation = createAsyncThunk(
  `GET_TRADE_CONFIRMATION`,
  async ({ page, limit, startDate, endDate, tradeType }, { rejectWithValue }) => {
    try {
      const response = await getTradeConfirmationService(page, limit, startDate, endDate, tradeType);
      return response;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const getSubscriptionAgreements = createAsyncThunk(
  `GET_SUBSCRIPTION_AGREEMENTS`,
  async ({ page, limit, startDate, endDate }, { rejectWithValue }) => {
    try {
      const response = await getSubscriptionAgreementService(page, limit, startDate, endDate);
      return response;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const accountStatementSlice = createSlice({
  name: 'accountStatementSlice',
  initialState,
  reducers: {
    resetTradeConfirmations: (state) => {
      state.tradingConfirmationList = {
        totalCount: 0,
        totalPage: 0,
        tradingConfirmationData: [],
      };
    },
    resetSubscriptionAgreements: (state) => {
      state.subscriptionAgreementsList = {
        totalCount: 0,
        totalPage: 0,
        subscriptionAgreementData: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTradeConfirmation.fulfilled, (state, { payload }) => {
        if (!payload.data?.isError) {
          const { count, totalPage, tradingConfirmationList } = payload?.data?.data;
          state.tradingConfirmationList = {
            totalCount: count ?? 0,
            totalPage: totalPage ?? 0,
            tradingConfirmationData: [...(tradingConfirmationList ?? [])],
          };
        }
      })
      .addCase(getTradeConfirmation.rejected, (_, { payload }) => {
        toastNotify('error', payload?.response?.data?.message ?? 'Something went wrong!');
      });

    builder
      .addCase(getSubscriptionAgreements.fulfilled, (state, { payload }) => {
        if (!payload.data?.isError) {
          const { count, totalPage, purchaseAgreementList } = payload?.data?.data;
          state.subscriptionAgreementsList = {
            totalCount: count ?? 0,
            totalPage: totalPage ?? 0,
            subscriptionAgreementData: [...(purchaseAgreementList ?? [])],
          };
        }
      })
      .addCase(getSubscriptionAgreements.rejected, (_, { payload }) => {
        toastNotify('error', payload?.response?.data?.message ?? 'Something went wrong!');
      });
  },
});

export const { resetTradeConfirmations, resetSubscriptionAgreements } = accountStatementSlice.actions;

export default accountStatementSlice.reducer;
